import { createAction, createAsyncAction } from 'typesafe-actions'
import Visualization from '../../../entities/Visualization'

export const fetchVisualization = createAction('CMD / Visualization / fetch')()

export const fetchVisualizationAsync = createAsyncAction(
    'EVT / Visualization / fetch request',
    'EVT / Visualization / fetch success',
    'EVT / Visualization / fetch failure',
)<undefined, Visualization, Error>()

export const setVisualizationState = createAction('DOC / Visualization / set state')<Visualization>()

export const resetVisualizationState = createAction('DOC / Visualization / reset state')<void>()
